// extracted by mini-css-extract-plugin
export default {"container":"pre-dealer-detail_container__j1VRr","tableHeader":"pre-dealer-detail_tableHeader__tuDhu"};